const X = () => {
  return (
    <path d="M2.34564 24C1.02979 24 0 22.9404 0 21.623C0 20.9928 0.228828 20.3913 0.686514 19.9617L8.61021 12L0.686514 4.0668C0.228828 3.6086 0 3.03578 0 2.40572C0 1.05964 1.02979 0.0572751 2.34564 0.0572751C3.00356 0.0572751 3.51846 0.286378 3.97614 0.715989L11.957 8.67779L19.9952 0.687336C20.4815 0.200479 20.9964 0 21.6256 0C22.9414 0 24 1.03102 24 2.34845C24 3.00716 23.7996 3.52267 23.2847 4.03818L15.3325 12L23.2563 19.9332C23.7425 20.3629 23.9713 20.9641 23.9713 21.623C23.9713 22.9404 22.913 24 21.5685 24C20.9106 24 20.3098 23.771 19.8807 23.3126L11.957 15.3509L4.06194 23.3126C3.60428 23.771 3.00356 24 2.34564 24Z" />
  );
};

export default X;
